import React from "react";
import MDInput from "./components/mdInput";

function App() {
  return (
    <div>
      <div>
        <h1 id="main-heading">Markdown Previewer</h1>
      </div>
      <MDInput />
    </div>
  );
}

export default App;
